export default __webpack_public_path__ + "static/media/onprofit.alt.6a1a952e.png";